import { useEffect, useState } from "react";
import { api } from "@/App";
import { History, RefreshCw } from "lucide-react";

const ACTION_COLOR = {
  created: "text-emerald-300 bg-emerald-500/10 border-emerald-500/30",
  updated: "text-cyan-300 bg-cyan-500/10 border-cyan-500/30",
  removed: "text-red-300 bg-red-500/10 border-red-500/30",
};

export default function Logs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    setLoading(true);
    const r = await api.get("/deployment-log");
    setLogs(r.data);
    setLoading(false);
  };
  useEffect(() => { refresh(); }, []);

  return (
    <div className="p-8 max-w-4xl">
      <div className="flex items-start justify-between mb-6">
        <div>
          <div className="flex items-center gap-2 text-emerald-400 text-xs uppercase tracking-widest mb-1">
            <History size={14} /> Audit
          </div>
          <h1 className="text-3xl font-bold tracking-tight">Deployment Log</h1>
          <p className="text-slate-400 mt-1 text-sm">Every signature push, update, and removal.</p>
        </div>
        <button onClick={refresh} className="btn" disabled={loading} data-testid="logs-refresh">
          <RefreshCw size={14} className={loading ? "animate-spin" : ""} /> Refresh
        </button>
      </div>

      <div className="glass overflow-hidden">
        {logs.length === 0 ? (
          <div className="p-8 text-center text-slate-500 text-sm">No deployments yet.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="text-xs text-slate-400 border-b border-white/5">
              <tr>
                <th className="text-left px-4 py-2">When</th>
                <th className="text-left px-4 py-2">Action</th>
                <th className="text-left px-4 py-2">Mailbox</th>
                <th className="text-left px-4 py-2">Rule</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l, i) => (
                <tr key={i} className="border-b border-white/5">
                  <td className="px-4 py-2.5 text-slate-400 text-xs">{new Date(l.at).toLocaleString()}</td>
                  <td className="px-4 py-2.5">
                    <span className={`text-[11px] px-2 py-0.5 rounded-full border ${ACTION_COLOR[l.action] || "text-slate-400 bg-slate-700/30 border-slate-700"}`}>
                      {l.action}
                    </span>
                  </td>
                  <td className="px-4 py-2.5">{l.mail}</td>
                  <td className="px-4 py-2.5 text-slate-400 text-xs">{l.rule_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
